/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-31T13:40:03+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-08-31T13:43:20+02:00
*/


export const LANDSCAPE = 'landscape';
export const PORTRAIT = 'portrait';

export default {
  landscape: LANDSCAPE,
  portrait: PORTRAIT,
};
